<script setup lang="ts">
import { resizeImage, resizeImageSrcsetWidths } from '~/shared/lib/resizeImage';

const props = defineProps<{
  image: string;
  source?: string;
  description?: string;
  imageWidth?: number | null;
  imageHeight?: number | null;
}>();

const aspectRatio = computed(() =>
  props.imageWidth && props.imageHeight
    ? `${props.imageWidth} / ${props.imageHeight}`
    : undefined,
);
</script>

<template>
  <figure v-if="image" :class="$style.image">
    <div
      :class="$style.image__wrapper"
      :style="aspectRatio ? { aspectRatio } : undefined"
    >
      <img
        :src="resizeImage(image, { width: 860 })"
        :srcset="
          resizeImageSrcsetWidths(image, [480, 720, 860, 1280, 1720, 2580]) ||
          undefined
        "
        sizes="(max-width: 900px) 100vw, 860px"
        :class="$style.image__img"
        :alt="description ?? ''"
        :width="imageWidth ?? undefined"
        :height="imageHeight ?? undefined"
      />
    </div>
    <figcaption v-if="source" :class="$style.image__source">
      {{ source }}
    </figcaption>
  </figure>
</template>

<style module lang="scss">
.image {
  display: flex;
  flex-flow: column nowrap;
  gap: var(--space-1x);
  padding: 0;
  margin: var(--space-2x) 0 var(--space-2x);

  &__wrapper {
    position: relative;
    display: flex;
    overflow: hidden;
  }

  &__img {
    width: 100%;
    height: auto;
    margin: 0 !important;
    display: block;
  }

  &__source {
    @include text_body2;
    color: var(--color-gray-text);
  }
}

@media (max-width: 479px) {
  .image {
    &__wrapper {
      margin-left: -20px;
      margin-right: -20px;
      width: calc(100% + 40px);
    }
  }
}
</style>
